module.exports = __webpack_public_path__ + "media/images/ding-dash-logo-white-28589cfb5d5a4e653aa46bedd8ce6740.png";